<script lang="ts">
import Label from '@/core/Label.svelte'
import Select from '@/core/Select.svelte'
import SelectItem from '@/core/SelectItem.svelte'
import { createElementId, type FormErrors, type SelectOption } from '@/modules/form'

import FieldValidationMessage from './FieldValidationMessage.svelte'
import ValidationMessage from './ValidationMessage.svelte'

type Props = {
	id?: string
	label?: string
	value: string
	name: string
	errors: FormErrors
	options: SelectOption[]
	placeholder?: string
	onChange?: (e: Event) => void
	onBlur?: (e: Event) => void
}

let {
	id = `input-${createElementId()}`,
	label,
	value = $bindable(),
	name,
	errors,
	options,
	placeholder,
	onChange,
	onBlur,
	...rest
}: Props = $props()

let isInvalid = $derived(Boolean(errors[name]))
</script>

<div class="relative mb-3">
	{#if label}<Label for={id}>{label}</Label>{/if}
	<Select bind:value {id} {name} {placeholder} {isInvalid} {onChange} {onBlur} {...rest} testId={`${name}Select`}>
		{#each options as option (option.value)}
			<SelectItem text={option.text} value={option.value} />
		{/each}
	</Select>
	{#if isInvalid}
		<FieldValidationMessage>
			<ValidationMessage {name} {errors} />
		</FieldValidationMessage>
	{/if}
</div>
